






























































import Vue from 'vue';
export default Vue.extend({
  props: {
    itemsLength: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 8
    },
    itemsPerPageArray: {
      type: Array,
      default: () => [4, 8, 12, 25, 50]
    }
  },
  data: () => ({}),
  computed: {
    numberOfPages(): number {
      let numberOfPages = Math.floor(this.itemsLength / this.itemsPerPage);
      const remainder = this.itemsLength % this.itemsPerPage;
      if (remainder > 0) {
        numberOfPages += 1;
      }
      return numberOfPages;
    },
    pageStart(): number {
      // might have tio be exhibitors length not ordered exhibitors
      if (this.itemsPerPage === -1 || !this.itemsLength) return 0;

      return (this.page - 1) * this.itemsPerPage;
    },
    pageStop(): number {
      if (this.itemsPerPage === -1) return this.itemsLength;
      // might have tio be itemsLength not ordered itemsL     if (!this.itemsLength) return 0;

      return Math.min(this.itemsLength, this.page * this.itemsPerPage);
    }
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages)
        this.$emit('nextPage', this.page + 1);
    },
    formerPage() {
      if (this.page - 1 >= 1) this.$emit('formerPage', this.page - 1);
    },
    updateItemsPerPage(number: number) {
      this.$emit('updateItemsPerPage', number);
    }
  }
});
